import React from 'react'
import classNames from 'classnames'
import { GxIcon } from '@garpix/garpix-web-components-react'
import {
  championshipStar,
  championshipTrophy,
  championshipWaiting
} from '@/images'
import style from './styles/championship.module.scss'
import { Link } from 'react-router-dom'
import Button from '../Button'
import Tag from '../Tag'
import { IChampionship } from '@/interfaces/Championship'
import useGame from '@/hooks/useGame'
import ScoreTag from '../Tag/ScoreTag'
import PlaceTag from '../Tag/PlaceTag'
import { useModal, usePage } from '@/hooks'
import AgeTag from '../Tag/AgeTag'

interface IProps {
  championship: IChampionship
  isCabinetCard?: boolean
}

const ChampionshipSmallCard = ({
  championship,
  isCabinetCard = false
}: IProps): React.ReactElement => {
  const page = usePage()
  const { openModal } = useModal()

  const {
    id,
    property_is_finished_value: finished,
    property_tourney_register_closed_value: registerClosed,
    property_jeka_version_value: version,
    place = null,
    score = null,
    scores = [],
    property_tourney_code_value: tourneyCode,
    property_age_group_value: age
  } = championship

  const handleOpenModal = (): void => {
    openModal('championshipCode', {
      tourneyCode
    })
  }

  const gameInfo = useGame(version)

  const isFinish = Boolean(Number(finished))
  const isWaiting = Boolean(Number(registerClosed)) && !isFinish
  const isOpen = !isWaiting && !isFinish

  const slicededDateCreate =
    championship.date_create !== null
      ? championship.date_create.slice(0, 10)
      : ''

  const link = page.init_state.global.config.championship_detail
  return (
    <div className={style.small_wrap}>
      <Link to={`${link}?element_id=${id}`} className={style.small}>
        <div
          className={classNames({
            [style.small_status]: true,
            [style.small_status__open]: isOpen,
            [style.small_status__completed]: isFinish,
            [style.small_status__waiting]: isWaiting
          })}
        >
          {isOpen
            ? (
              <>
                <GxIcon src={championshipStar} className={style.small__icon} />
                Открыт
              </>
              )
            : (
                ''
              )}
          {isFinish
            ? (
              <>
                <GxIcon src={championshipTrophy} className={style.small__icon} />
                Завершен
              </>
              )
            : (
                ''
              )}
          {isWaiting
            ? (
              <>
                <GxIcon src={championshipWaiting} className={style.small__icon} />
                Ожидание
              </>
              )
            : (
                ''
              )}
        </div>
        <div
          className={classNames({
            [style.small_right]: true,
            [style['small_right--cabinet']]: isCabinetCard
          })}
        >
          <div className={style.small_info}>
            <p className={style.small__title}>{championship.name}</p>
            <ul className={style.small_tags}>
              {gameInfo !== undefined
                ? (
                  <li className={style.small_tags__item}>
                    <Tag title={gameInfo.name} />
                  </li>
                  )
                : (
                    ''
                  )}
              {age !== null
                ? (
                  <li className={style.small_tags__item}>
                    <AgeTag age={age} />
                  </li>
                  )
                : (
                    ''
                  )}
              {place !== null
                ? (
                  <li className={style.small_tags__item}>
                    <PlaceTag place={place} />
                  </li>
                  )
                : (
                    ''
                  )}
              {score !== null
                ? (
                  <li className={style.small_tags__item}>
                    <ScoreTag title={score} />
                  </li>
                  )
                : (
                    ''
                  )}
              {Array.isArray(scores) && scores.length > 0
                ? (
                  <>
                    <li className={style.small_tags__item}>
                      <ScoreTag title={scores[scores.length - 1].score} />
                    </li>
                    <li className={style.small_tags__item}>
                      <ScoreTag title={scores[scores.length - 1].stage} />
                    </li>
                  </>
                  )
                : null}
            </ul>
          </div>
          {isOpen && !isCabinetCard
            ? (
              <Button
                size='medium'
                highlight
                wide
                className={style.small__button}
              >
                Участвовать
              </Button>
              )
            : (
                ''
              )}
          {isOpen && isCabinetCard
            ? (
              <span className={style.small__participate}>Вы уже участвуете</span>
              )
            : (
                ''
              )}
          {isFinish
            ? (
              <span
                className={classNames({
                  [style.small__date]: true,
                  [style['small__date--cabinet']]: isCabinetCard
                })}
              >
                {slicededDateCreate}
              </span>
              )
            : (
                ''
              )}
        </div>
      </Link>
      {isWaiting && isCabinetCard
        ? (
          <Button
            size='medium'
            highlight
            wide
            className={style.small__button}
            onClick={handleOpenModal}
          >
            Получить код
          </Button>
          )
        : (
            ''
          )}
    </div>
  )
}

export default ChampionshipSmallCard
